/* eslint-disable no-console */
import { PollingStatus } from './pollStatus';

const isDev = process.env.NODE_ENV === 'development';

export type LogDataType = {
  jobId?: string;
  metricId: string;
  eventName: string;
  dateTime: string;
  data: any;
};

export class VQMetrics {
  metricId: string;

  enabled: boolean = false;

  constructor(enabled: boolean) {
    this.metricId = window.crypto?.randomUUID?.() || 'legacy-browser-id';
    this.enabled = enabled;
  }

  public logEvent(data: LogDataType) {
    if (isDev) console.log(data);
    if (!this.enabled) return;
    const payload = {
      ...data,
      metricId: this.metricId,
    };
    fetch('/vq/metrics/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).catch((err) => {
      if (isDev) console.error(err);
    });
  }

  logPageLoad() {
    this.logEvent({
      metricId: this.metricId,
      eventName: 'page_load',
      dateTime: new Date().toISOString(),
      data: {},
    });
  }

  logInitialised({ jobId }: { jobId?: string }) {
    this.logEvent({
      jobId,
      metricId: this.metricId,
      eventName: 'initialised',
      dateTime: new Date().toISOString(),
      data: {},
    });
  }

  logErrorDisplayed({ errorCode, jobId }: { errorCode: string; jobId?: string }) {
    this.logEvent({
      jobId,
      metricId: this.metricId,
      eventName: 'error_displayed',
      dateTime: new Date().toISOString(),
      data: { errorCode },
    });
  }

  logError({ error, jobId }: { error: string; jobId?: string }) {
    this.logEvent({
      jobId,
      metricId: this.metricId,
      eventName: 'error',
      dateTime: new Date().toISOString(),
      data: { error },
    });
  }

  logStatusUpdated({
    status,
    jobId,
    errorCode,
  }: {
    status: PollingStatus;
    jobId?: string;
    errorCode?: string;
  }) {
    this.logEvent({
      jobId,
      metricId: this.metricId,
      eventName: 'status_updated',
      dateTime: new Date().toISOString(),
      data: { status, errorCode },
    });
  }

  logRedirect({ jobId }: { jobId?: string }) {
    this.logEvent({
      jobId,
      metricId: this.metricId,
      eventName: 'redirect',
      dateTime: new Date().toISOString(),
      data: {},
    });
  }
}
